import script from "./Locais.vue?vue&type=script&setup=true&lang=js"
export * from "./Locais.vue?vue&type=script&setup=true&lang=js"

import "./Locais.vue?vue&type=style&index=0&id=63c3197a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c3197a"]])

export default __exports__